import { UserMessage } from './msgInterface'
import { CoverPage } from '../components/coverPage'
import { AscCoverPage } from '../components/AscCoverPage'
import PluginInterface from './pluginInterface'
import { getPayloadFromCoverOption } from './utils/coverpageUtils'

type data = {
    sender_id: string
    initial_payload: string
    auth_token: string
    testing: object | null
    plugin: string
    endpoint_url: string
    coverpage_text: string
    coverpage_options: string
    coverpage_button_text: string
    coverpage_title: string
    coverpage_redirect_plugin: string
    coverpage_dropdown_subheader: string
}

export default class CoverPagePlugin implements PluginInterface{
    REQUIRED_DATA = []
    data: data

    constructor(data: data) {
        this.data = data
    }

    async processInput(input: UserMessage): Promise<object | undefined> {
        if (input.payload === '/coverpage') {
            return {
                coverpageComponent: CoverPage,
                options: {
                    title: this.data.coverpage_title,
                    options: this.data.coverpage_options,
                    dropdownSubheader: this.data.coverpage_dropdown_subheader,
                    buttonText: this.data.coverpage_button_text,
                    text: this.data.coverpage_text, 
                    redirectPlugin: this.data.coverpage_redirect_plugin,
                }
            }
        }
        if (input.payload === '/asccoverpage') {
            return {
                coverpageComponent: AscCoverPage,
                options: {
                    title: this.data.coverpage_title,
                    options: this.data.coverpage_options,
                    dropdownSubheader: this.data.coverpage_dropdown_subheader,
                    buttonText: this.data.coverpage_button_text,
                    text: this.data.coverpage_text, 
                    redirectPlugin: this.data.coverpage_redirect_plugin,
                }
            }
        }
        if (input.payload === '/resetCoverpage') {
            return
        }
        if (input.payload === '/submitCoverpage') {
            let payload = getPayloadFromCoverOption(this.data.coverpage_options, input.message ?? '')
            let passControlResponse: Array<object> = [{
                pass_control: this.data.coverpage_redirect_plugin,
                message: payload ? payload : input.message,
                options: input.options
            }]
            return passControlResponse
        }
    }
}